/// ///////////////////////////////////////////////////////////////////////////
//  Copyright (C) 2013 by sanpolo CO.LTD                                    //
//                                                                          //
//  This file is part of WIDE                                               //
//                                                                          //
//  You should have received a copy of the WIDE License along with this     //
//  program.  If not, see <http://www.wware.org/wide/license.html>.         //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// ///////////////////////////////////////////////////////////////////////////
// Created At : 2019-02-28T09:47:56.262Z by lizhutang (lizhutang@spolo.org)

'use strict'

import bootstrap from './bootstrap'
import layerjs from './layerjs'
import wwclass from './wwclass'
import wwtype from './wwtype'
import img from './img'

export default [
  bootstrap,
  layerjs,
  wwclass,
  img,
  wwtype
]
